<template>
  <div>
    <b-overlay :show="loading" :opacity="0" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner />
      </template>
      <b-row v-if="!users || users.length < 1">
        <discover-no-user>
          <h3 class="color-black">
           {{ $t('You haven\'t blocked anyone yet') }}
          </h3>
        </discover-no-user>
      </b-row>
      <b-row v-for="user in users" :key="user.id">
        <blocked-user-card :user="user" @setLoading="setLoading($event)" @getUsers="getUsers" />
<!--        <user-card v-for="user in users" :key="user.id" :user="user" @setLoading="setLoading($event)"/>-->
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay, BRow } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import UserCard from '@/components/UserCard'
import DiscoverNoUser from '@/components/DiscoverNoUser'
import {showNotify, throwDefaultError} from '@/helpers/helpers'
import BlockedUserCard from '@/components/BlockedUserCard'

export default {
  name: 'interaction-blocked-users',
  props: {
    activeTabIndex: {
      type: Number,
      default: 1
    }
  },
  components: {
    BRow,
    BOverlay,

    BlockedUserCard,
    DiscoverNoUser,
    UserCard,
  },
  data() {
    return {
      loading: false,
      scrollOffsetForLoadMore: 100,
      users: [],
      usersLimit: 100,
      usersOffset: 0,
      usersAllLoaded: false,
    }
  },
  created() {
    this.getUsers()

    // Scroll'u dinle
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {

  },
  methods: {
    getUsers(clear = true) {
      this.loading = true
      useJwt.getBlockedUsers(this.usersOffset, this.usersLimit)
          .then(response => {
            if (clear) {
              this.users = response.data.body.users
            } else {
              this.users.push(...response.data.body.users)
            }

            // Offset ayarla
            this.usersOffset = response.data.body.offset + response.data.body.limit

            if (this.usersOffset >= response.data.body.totalCount) {
              this.usersAllLoaded = true
            }
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
    },
    handleScroll (event) {
      if (this.activeTabIndex === 3) {
        if ((window.innerHeight + window.scrollY + this.scrollOffsetForLoadMore) >= document.body.scrollHeight &&
            !this.usersAllLoaded) {
          this.loadMore()
        }
      }
    },
    loadMore() {
      if (!this.loading) {
        this.getUsers(false)
      }
    },
    setLoading($event) {
      this.loading = $event
    },
  }
}
</script>

<style lang="scss">
/* Set the theme color of the component */
$themeColor: #F9447A;

/* import theme style */
@import '~vue-slider-component/lib/theme/default.scss';
</style>
